import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/programming-module-three.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M192 32H64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32m16 160a16 16 0 0 1-16 16H64a16 16 0 0 1-16-16V64a16 16 0 0 1 16-16h128a16 16 0 0 1 16 16ZM104 92a12 12 0 1 1-12-12 12 12 0 0 1 12 12m36 36a12 12 0 1 1-12-12 12 12 0 0 1 12 12m36 36a12 12 0 1 1-12-12 12 12 0 0 1 12 12" }, null, -1)])]);
}
var programming_module_three_default = { render };
//#endregion
export { programming_module_three_default as default, render };

//# sourceMappingURL=programming-module-three.svg.js.map